module.exports = __webpack_public_path__ + "static/media/fixed_voice_plus.d4fad04a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fixed_voice_plus.svg
// module id = 554
// module chunks = 0